import * as api from '../coOpApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  coOpActionCreators,
  CoOpActionKeys,
  FetchCoOpRequest,
  ICoOpRequest
  } from '..';
import { uiActionCreators } from '../../ui';

function* fetchCoOpRequestSaga(action: FetchCoOpRequest) {
  yield put(uiActionCreators.showFullPageLoading());
  const response: ICoOpRequest = yield call(api.fetchCoOpRequest, action.payload.coOpRequestId);

  yield put(uiActionCreators.hideFullPageLoading());
  yield put(coOpActionCreators.setRequests([response]));
}

export function* watchFetchCoOpRequest() {
  yield takeEvery(CoOpActionKeys.FETCH_COOP_REQUEST, fetchCoOpRequestSaga);
}
